/* Sigma Strategic — movimiento e interacción */
(function () {
  var root = document.getElementById('sg');
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };

  /* títulos palabra a palabra (conserva <em> y .hl) */
  $$('[data-split]').forEach(function (el) {
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'); w.className = 'w';
            var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--d', (i++ * 0.07).toFixed(2) + 's');
            w.appendChild(s); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.classList.contains('hl')) walk(n);
        else if (n.nodeType === 1) { n.style.setProperty('--d', (i++ * 0.07).toFixed(2) + 's'); }
      });
    })(el);
  });

  /* aparición al hacer scroll */
  var items = $$('[data-rv],[data-split],.sg-stage');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  } else items.forEach(function (el) { el.classList.add('is-in'); });

  /* contadores */
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var el = e.target, to = +el.getAttribute('data-count'), t0 = performance.now();
        if (reduce) return;
        (function step(t) { var p = Math.min(1, (t - t0) / 1300); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 4))); if (p < 1) requestAnimationFrame(step); })(t0);
      });
    }, { threshold: .6 });
    $$('[data-count]').forEach(function (el) { cio.observe(el); });
  }

  /* menú móvil */
  var burger = $('.sg-burger'), menu = $('.sg-menu');
  function close() { root.classList.remove('menu-open'); burger.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  burger.addEventListener('click', function () {
    var o = !root.classList.contains('menu-open');
    root.classList.toggle('menu-open', o); burger.setAttribute('aria-expanded', o); menu.setAttribute('aria-hidden', !o);
    document.documentElement.style.overflow = o ? 'hidden' : '';
    $$('a', menu).forEach(function (a, i) { a.style.transitionDelay = (0.05 + i * 0.05) + 's'; });
  });
  $$('a', menu).forEach(function (a) { a.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* FAQ: solo una abierta */
  $$('.sg-faq details').forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) $$('.sg-faq details').forEach(function (o) { if (o !== d) o.open = false; }); }); });

  /* anclas suaves con compensación de la barra */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]'); if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
    e.preventDefault(); window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 70, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* scroll: barra, progreso, portfolio horizontal */
  var nav = $('#sg-nav'), prog = $('.sg-progress'), pin = $('#sg-pin'), track = $('#sg-track'), cnt = $('.sg-count'), cnum = $('#sg-cnum'), tick = false;
  var sites = $$('.sg-site');
  function layoutPin() {
    if (!pin || !track) return;
    pin.style.removeProperty('--pinh'); return;
    var dist = track.scrollWidth - window.innerWidth;
    pin.style.setProperty('--pinh', (window.innerHeight + Math.max(0, dist)) + 'px');
  }
  function onScroll() {
    tick = false;
    var y = window.scrollY, H = document.documentElement.scrollHeight - innerHeight;
    nav.classList.toggle('is-scrolled', y > 30);
    prog.style.transform = 'scaleX(' + (H > 0 ? y / H : 0) + ')';
    root.classList.toggle('show-bar', y > innerHeight * .8);
    if (false) {
      var r = pin.getBoundingClientRect(), total = pin.offsetHeight - innerHeight;
      var p = Math.max(0, Math.min(1, -r.top / Math.max(1, total)));
      var dist = track.scrollWidth - window.innerWidth;
      track.style.transform = 'translate3d(' + (-p * dist) + 'px,0,0)';
      if (cnt) cnt.style.setProperty('--p', p.toFixed(3));
      if (cnt) cnt.querySelector('b').style.transform = 'scaleX(' + p + ')';
      if (cnum) cnum.textContent = '0' + Math.min(sites.length, 1 + Math.round(p * (sites.length - 1)));
    }
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', function () { layoutPin(); onScroll(); });
  window.addEventListener('load', function () { layoutPin(); onScroll(); });
  layoutPin(); onScroll();


  /* carrusel de webs: pasa solo, flechas, arrastre y swipe */
  (function () {
    if (!track) return;
    var items = sites, idx = 0, timer = null, bar = cnt && cnt.querySelector('b');
    function cur() { var best = 0, bd = 1e9, mid = track.scrollLeft + track.clientWidth / 2; items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft + it.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } }); return best; }
    function paint() { idx = cur(); if (cnum) cnum.textContent = '0' + (idx + 1); if (bar) bar.style.transform = 'scaleX(' + ((idx + 1) / items.length) + ')'; }
    function go(i) { idx = (i + items.length) % items.length; var it = items[idx]; track.scrollTo({ left: it.offsetLeft - (track.clientWidth - it.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
    function play() { stop(); if (!reduce) timer = setInterval(function () { go(cur() + 1); }, 3500); }
    function stop() { clearInterval(timer); }
    var pv = document.getElementById('sg-prev'), nx = document.getElementById('sg-next');
    if (pv) pv.addEventListener('click', function () { go(cur() - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(cur() + 1); play(); });
    track.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stop(); });
    track.addEventListener('pointerleave', play);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', function () { setTimeout(play, 2500); });
    /* arrastrar con el ratón */
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = track.scrollLeft; track.classList.add('drag'); });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; track.classList.remove('drag'); go(cur()); });
    window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - sx; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = sl - dx; });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { en.forEach(function (e) { e.isIntersecting ? play() : stop(); }); }, { threshold: .3 }).observe(track);
    paint();
  })();

  /* efectos de ratón (solo escritorio) */
  if (fine && !reduce) {
    var spot = $('.sg-spot');
    window.addEventListener('pointermove', function (e) { spot.style.setProperty('--mx', e.clientX + 'px'); spot.style.setProperty('--my', e.clientY + 'px'); }, { passive: true });
    $$('.sg-card').forEach(function (c) {
      c.addEventListener('pointermove', function (e) { var r = c.getBoundingClientRect(); c.style.setProperty('--cx', (e.clientX - r.left) + 'px'); c.style.setProperty('--cy', (e.clientY - r.top) + 'px'); });
    });
    var stage = $('#sg-stage'), deck = $('#sg-deck');
    if (stage && deck) {
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        deck.style.transform = 'rotateY(' + (x * 12) + 'deg) rotateX(' + (-y * 10) + 'deg)';
      });
      stage.addEventListener('pointerleave', function () { deck.style.transform = ''; });
    }
    /* botones magnéticos */
    $$('.sg-btn-p').forEach(function (b) {
      b.addEventListener('pointermove', function (e) { var r = b.getBoundingClientRect(); b.style.translate = ((e.clientX - r.left - r.width / 2) * .15) + 'px ' + ((e.clientY - r.top - r.height / 2) * .25) + 'px'; });
      b.addEventListener('pointerleave', function () { b.style.translate = ''; });
    });
  }
})();
